import { Button, Card, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { SelectableImage } from "shared/components/organisms/SelectableImage";
import { Flex } from "styled-system/jsx";
import { css } from "styled-system/css";
import { isLandscape } from "shared/utils/isLandscape";
import { limitFill } from "@cloudinary/url-gen/actions/resize";
import { autoGravity } from "@cloudinary/url-gen/qualifiers/gravity";
import { formatDate } from "shared/utils/formatDate";
import { DATE_RANGE } from "shared/utils/formatDate";
import { getMultilingualString } from "shared/utils/getMultilingualString";
import { EventWithOccurrences } from "gql/generated";

type WidgetItemEventCardProps = {
  event: EventWithOccurrences;
  handleEventDetailsClick: (event: EventWithOccurrences) => void;
};

export const WidgetItemEventCard = ({
  event,
  handleEventDetailsClick,
}: WidgetItemEventCardProps) => {
  const { t } = useTranslation();
  const hero = event.images.length > 0 ? event.images[0] : undefined;

  return (
    <Card.Surface
      boxShadow={"none"}
      borderTopWidth={"0"}
      borderLeftWidth={"0"}
      borderRightWidth={"0"}
      borderRadius={"0"}
    >
      <Card.Body
        pt="0"
        pb="150"
        px={"1px"}
        display="flex"
        flexDir="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Flex flexDir="row" alignItems="center" gap={250}>
          {/* New selectable image component ... currently set to disabled because we have no bulk actions */}
          <SelectableImage
            selected={false}
            onSelectionChange={(isSelected) => console.log(isSelected)}
            image={hero}
            imageStyleProps={{
              className: css({
                borderRadius: "full",
                objectFit: "cover",
                width: "60px",
                height: "60px",
              }),
            }}
            resize={
              isLandscape(hero)
                ? limitFill().height(60).gravity(autoGravity())
                : limitFill().width(60).gravity(autoGravity())
            }
            size="lg"
            visual="accent"
            disabled={true}
          />

          <Flex flexDir="column" gap="50">
            {/* Ensure the name stays on one line */}
            <Text color="text.dark" visual="bodySemiBold" lineClamp={1}>
              {getMultilingualString(event.title)}
            </Text>
            {event.updatedDateISO && (
              <Text color="text.light" visual="smallMedium" lineClamp={1}>
                {t("core:DATE_RANGES.UPDATED")}:&nbsp;
                {formatDate(event.updatedDateISO, DATE_RANGE)}
              </Text>
            )}
          </Flex>
        </Flex>

        <Button
          visual={"primary"}
          mode={"light"}
          size={"sm"}
          css={{
            "& svg": { width: "icons.sm", height: "icons.sm" },
          }}
          onClick={() => {
            handleEventDetailsClick(event);
          }}
        >
          {t("widgets:DETAILS.CTA_BUTTONS.EDIT_DETAILS")}
        </Button>
      </Card.Body>
    </Card.Surface>
  );
};
